"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportModal = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var input_select_1 = require("../../components/input/input.select");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var form_import_ctrl_1 = require("./form.import.ctrl");
var FORM_IMPORT_SUCCEED = { key: i18n_1.T.FORM_IMPORT_SUCCEED };
var FormImportModalCSS = {
    container: 'c-FormImportModal',
    text: 'c-FormImportModal__text',
    file: 'c-FormImportModal__file',
    form: 'c-FormImportModal__form',
    copyTitle: 'c-FormImportModal__copy-title',
    isActive: 'c-FormImportModal--is-active'
};
(0, theme_1.addStyles)((_a = {},
    _a[FormImportModalCSS.form] = {
        width: '100%'
    },
    _a[FormImportModalCSS.container] = {
        width: '100%',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            border: '1px solid ' + theme_1.DefaultTheme.color.accent,
            cursor: 'pointer'
        }
    },
    _a[FormImportModalCSS.file] = {
        display: 'none'
    },
    _a[FormImportModalCSS.copyTitle] = {
        marginTop: '10px'
    },
    _a));
var FormImportModal = /** @class */ (function (_super) {
    tslib_1.__extends(FormImportModal, _super);
    function FormImportModal(ctrl) {
        var _this = _super.call(this, {
            title: i18n_1.T.FORM_IMPORT,
            confirm: i18n_1.T.FORM_IMPORT_CONFIRM,
            success: FORM_IMPORT_SUCCEED
        }) || this;
        _this.loadingSecondaryForms = false;
        _this.ctrl = ctrl;
        _this.departmentSelectState = new input_select_1.SelectInputState('Department');
        _this.departmentSelectState.onValue(function () { return _this.loadSecondaryForms(); });
        for (var _i = 0, _a = services_1.Services.Department.departments; _i < _a.length; _i++) {
            var dept = _a[_i];
            _this.departmentSelectState.addOption({ key: dept.name, value: dept.objectId });
        }
        _this.secondaryFormSelectState = new input_select_1.SelectInputState('Form');
        _this.secondaryFormSelectState.disabled = true;
        _this.secondaryFormSelectState.onValue(function (formID) { _this.ctrl.secondaryFormId = formID; });
        _this.fileInputState = new input_state_1.InputState('File');
        _this.fileInputState.isRequired = true;
        _this.fileInputState.reaction(function () { return _this.ctrl.file && _this.ctrl.file.buffer; }, function () {
            if (_this.ctrl.file) {
                _this.fileInputState.setValue(_this.ctrl.file);
            }
            else {
                _this.fileInputState.setError('File is required.');
            }
        });
        _this.addState(_this.fileInputState);
        return _this;
    }
    FormImportModal.prototype.loadSecondaryForms = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deptRest, forms, _i, forms_1, form;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.departmentSelectState.value) {
                            return [2 /*return*/];
                        }
                        (0, mobx_1.runInAction)(function () { _this.loadingSecondaryForms = true; });
                        deptRest = new core_shared_1.IkeRestDepartment(services_1.Services.User.rest, this.departmentSelectState.value);
                        return [4 /*yield*/, deptRest.formSummaries.fetch()];
                    case 1:
                        forms = _a.sent();
                        this.secondaryFormSelectState.reset();
                        for (_i = 0, forms_1 = forms; _i < forms_1.length; _i++) {
                            form = forms_1[_i];
                            this.secondaryFormSelectState.addOption({ key: form.displayname, value: form.revision });
                        }
                        (0, mobx_1.runInAction)(function () { _this.loadingSecondaryForms = false; });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FormImportModal.prototype, "nodes", {
        get: function () {
            var className = FormImportModalCSS.container;
            if (this.ctrl.isActive) {
                className += ' ' + FormImportModalCSS.isActive;
            }
            return (0, mithril_1.m)('form', { className: FormImportModalCSS.form }, tslib_1.__spreadArray(tslib_1.__spreadArray([], (this.ctrl.file
                ? [
                    (0, mithril_1.m)('div', [
                        this.ctrl.file.name
                    ])
                ]
                : [
                    (0, mithril_1.m)('input', {
                        className: FormImportModalCSS.file,
                        type: 'file',
                        id: this.ctrl.fileId,
                        onchange: this.ctrl.onFile,
                        accept: form_import_ctrl_1.FormImportCtrl.ALLOWED_SUFFIXES.join(', ')
                    }, ''),
                    (0, mithril_1.m)('div', {
                        className: className,
                        onclick: this.ctrl.openFileDialog
                    }, [(0, i18n_1.Translate)(i18n_1.T.FORM_IMPORT_UPLOAD_BUTTON)])
                ]), true), [
                (0, mithril_1.m)('div', { className: FormImportModalCSS.copyTitle }, 'Copy custom fields from:'),
                input_select_1.SelectInputComponent.view(this.departmentSelectState),
                this.loadingSecondaryForms ? spinner_1.Spinner.view() : input_select_1.SelectInputComponent.view(this.secondaryFormSelectState)
            ], false));
        },
        enumerable: false,
        configurable: true
    });
    FormImportModal.prototype.submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ctrl.processFile()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormImportModal.prototype, "loadingSecondaryForms", void 0);
    return FormImportModal;
}(modal_form_component_1.ModalFormComponent));
exports.FormImportModal = FormImportModal;
//# sourceMappingURL=form.import.modal.js.map